module.exports = __webpack_public_path__ + "img/caas4m-m@1.9715f131.jpg";